module.exports = __webpack_public_path__ + "img/DK24744817.618ee7dc.png";